module.exports = __webpack_public_path__ + "img/svg/background-footer-menu-mobile.7bc65324b2337f352781d8bedf7aaa22.svg";